document.addEventListener('DOMContentLoaded', () => {
  if (window.tocInitialized) return;
  window.tocInitialized = true;

  const toc = document.getElementById('table-of-contents');
  if (!toc) return;

  const article = document.querySelector('article');
  if (!article) return;

  const headers = article.querySelectorAll('h2, h3');
  if (headers.length === 0) {
    toc.style.display = 'none'; // Oculta TOC si no hay encabezados
    return;
  }

  // Título TOC
  const tocTitle = document.createElement('strong');
  tocTitle.textContent = 'Table of Contents';
  toc.appendChild(tocTitle);

  // Lista UL
  const ul = document.createElement('ul');
  toc.appendChild(ul);

  headers.forEach(header => {
    if (!header.id) {
      // Generar ID limpio para enlace
      header.id = header.textContent.trim().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]/g, '');
    }

    const li = document.createElement('li');
    // Sangría para h3
    li.style.marginLeft = header.tagName === 'H3' ? '1.5rem' : '0';

    const a = document.createElement('a');
    a.href = `#${header.id}`;
    a.textContent = header.textContent;

    li.appendChild(a);
    ul.appendChild(li);
  });
});

